import { useEffect, useRef } from 'react';

/**
 * Fires `callback` when `flag` transitions true -> false. Never fires on mount
 * or on a rising edge, and always calls the latest callback (changing the
 * callback alone never fires).
 *
 * Used by the LC dashboards to fire one immediate silent refresh when the last
 * modal/drawer closes — the auto-refresh interval is paused while a modal is
 * open and restarts from zero on unpause, so edits made in a drawer would
 * otherwise sit stale for up to a full tick.
 */
export function useFallingEdge(flag: boolean, callback: () => void): void {
  const savedCallback = useRef(callback);
  savedCallback.current = callback;
  const prevFlag = useRef(flag);

  useEffect(() => {
    const wasSet = prevFlag.current;
    prevFlag.current = flag;
    if (wasSet && !flag) savedCallback.current();
  }, [flag]);
}
